import { render, staticRenderFns } from "./zAguardar.vue?vue&type=template&id=3621ac6e&scoped=true&"
import script from "./zAguardar.vue?vue&type=script&lang=js&"
export * from "./zAguardar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3621ac6e",
  null
  
)

export default component.exports